import { Injectable, EventEmitter, HostListener } from '@angular/core';
import { UserHelper } from './user.helper';
import { CanActivate, Router } from '@angular/router';
import { ApiService } from '../services/api.service';

@Injectable()
export class RouteGuardHelper implements CanActivate {
  constructor(private _UserHelper: UserHelper, public _ApiService: ApiService, public _Router: Router) {}

  canActivate(): boolean {
    if (this._UserHelper.isNoData) {
      this._ApiService.getClient().then(result => {
        this._UserHelper.setUser(result);
        if (!this._UserHelper.isSignedIn || !result) {
          ////console.log(!this._UserHelper.isSignedIn , !result);
          this._Router.navigate(['login']);
          return false;
        }
      });
    } else {
      if (!this._UserHelper.isSignedIn) {
        this._Router.navigate(['login']);
        return false;
      }
    }

    return true;
  }
}
